module.exports = __webpack_public_path__ + "static/media/sportsbook-background.3f8f91d5.jpg";